<script>
  import { router } from '@inertiajs/svelte'
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import EntityList from '../../components/entity/entity_list.svelte'
  import FilterBar from '../../components/filter_bar.svelte'
  import FilterCheckbox from '../../components/filter_checkbox.svelte'
  import FilterDate from '../../components/filter_date.svelte'
  import { Button } from '../../components/ui'
  import { confirm } from '../../components/confirm.js'
  import { inertiaAction } from '../../lib/inertia_action.js'

  let { boost_templates = [], total_count = 0, filters = {}, date_nav = {} } = $props()

  // Filter changes are a plain GET of the list; inline actions redirect back to the referer,
  // so they keep the filters on their own.
  const applyFilters = (changes) => {
    router.get('/boosts', { ...filters, ...changes }, { preserveState: true, preserveScroll: true })
  }

  const shiftDate = (days) => {
    const date = days < 0 ? date_nav.previous : date_nav.next
    if (date) applyFilters({ date })
  }

  const toggleActive = (item, active) => {
    inertiaAction(router, 'patch', `/boosts/${item.id}/${active ? 'activate' : 'deactivate'}`)
  }

  const archive = async (item) => {
    const confirmed = await confirm({
      title: 'Confirm Archive',
      variant: 'error',
      body: 'Archiving is permanent unless reversed by a developer. Are you sure?'
    })
    if (!confirmed) return
    inertiaAction(router, 'delete', `/boosts/${item.id}`)
  }

  // The server works out which row moved and its new position from the dropped order
  const onReorder = (newItems) => {
    inertiaAction(router, 'patch', '/boosts/reorder', { ordered_ids: newItems.map((row) => row.id) })
  }
</script>

<Layout>
  <PageHeader title="Boosts" subtitle="Ranked point multipliers applied across a college town" count={boost_templates.length} total={total_count}>
    {#snippet actions()}
      <Button href="/boosts/new" variant="primary" size="sm" icon="add">New Boost Template</Button>
    {/snippet}
  </PageHeader>

  <FilterBar>
    {#snippet start()}
      <FilterDate
        nav
        id="boost-filter-date"
        value={filters.date || ''}
        onchange={(v) => applyFilters({ date: v || undefined })}
        onshift={shiftDate}
      />

      <FilterCheckbox label="Active" checked={filters.active_only} onchange={(v) => applyFilters({ active_only: v || undefined })} />
    {/snippet}
  </FilterBar>

  <EntityList entity="boost" rows={boost_templates} dragEnabled onreorder={onReorder} onToggle={toggleActive} onDelete={archive}>
    {#snippet actions(item)}
      <Button href={item.edit_url} variant="ghost" size="xs" square icon="edit" title="Edit" aria-label="Edit" />
      <Button href={item.duplicate_path} variant="ghost" size="xs" square icon="duplicate" title="Duplicate" aria-label="Duplicate" />
      <Button variant="ghost" size="xs" square icon="delete" title="Archive" aria-label="Archive" class="text-error" onclick={() => archive(item)} />
    {/snippet}
  </EntityList>
</Layout>
